import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { FilesListStateService } from '@modules/files/services/files-list-state.service';
import { FilesService } from '@modules/files/services/files.service';
import { File } from '@modules/files/types/file';
import { FilesFilters } from '@modules/files/types/files-filters';
import { FilesListState } from '@modules/files/types/files-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-files-section',
  templateUrl: './files-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...FilesListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeFilesSectionComponent
  extends KnowledgeStitchSectionComponent<File, FilesFilters>
  implements OnInit
{
  protected readonly listStateService = inject(FilesListStateService, { self: true });
  protected readonly stitchService = inject(FilesService);

  public override ngOnInit(): void {
    this.state = new FilesFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: FilesListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new FilesFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
